export const ONBOARDING_STORAGE = {
  role: "onboarding_role",
  activeFlow: "onboarding_active_flow",
  neverShow: "onboarding_never_show",
  minimized: "onboarding_minimized",
  progressPrefix: "onboarding_progress_"
};

export const getProgressKey = (flow) =>
  `${ONBOARDING_STORAGE.progressPrefix}${flow}`;

export const clearOnboardingStorage = () => {
  localStorage.removeItem(ONBOARDING_STORAGE.role);
  localStorage.removeItem(ONBOARDING_STORAGE.activeFlow);
  localStorage.removeItem(ONBOARDING_STORAGE.neverShow);
  localStorage.removeItem(ONBOARDING_STORAGE.minimized);
  localStorage.removeItem(getProgressKey("customer"));
  localStorage.removeItem(getProgressKey("provider"));
};
